import { ORDER_TYPES } from '@exodus/fiat-client'
import { memoize } from 'lodash' // eslint-disable-line @exodus/restricted-imports/prefer-basic-utils -- TODO: fix next time we touch this file

const resultFunction = (isAssetSupportedByOrderType) =>
  memoize((assetName) => isAssetSupportedByOrderType(assetName, ORDER_TYPES.buy))

const isBuySupportedByAssetSelectorDefinition = {
  id: 'isBuySupportedByAsset',
  resultFunction,
  dependencies: [{ selector: 'isAssetSupportedByOrderType' }],
}

export default isBuySupportedByAssetSelectorDefinition
